export const ClosingSection = ({ onStart }) => (
  <>
    <section
      data-testid="closing-cta"
      className="border-y border-border bg-secondary/50 px-4 py-16 text-center sm:px-6 sm:py-20"
    >
      <h2 className="mx-auto max-w-2xl font-display text-3xl font-bold leading-tight text-royal-deep sm:text-4xl">
        Your entire operation. Finally connected.
      </h2>
      <button
        type="button"
        data-testid="closing-start-trial"
        onClick={onStart}
        className="mt-7 min-h-[52px] w-full max-w-sm rounded-lg bg-gold px-8 font-display text-sm font-bold uppercase tracking-[0.12em] text-royal-deep transition-colors duration-200 hover:bg-gold/90 sm:w-auto"
      >
        Start Your 14-Day Free Trial
      </button>
      <p className="mt-3 text-xs text-muted-foreground" data-testid="closing-trial-terms">
        14-day free trial. Card on file, no charge until day 14. Cancel anytime.
      </p>
    </section>

    <footer
      data-testid="splash-footer"
      className="bg-royal-deep px-4 py-10 sm:px-6"
      style={{ paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 2.5rem)" }}
    >
      <div className="mx-auto flex max-w-6xl flex-col gap-5 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="font-display text-base font-semibold text-white">Cornerstone Ops</p>
          <p className="mt-1.5 text-[11px] text-blue-200/50">
            A Christian-Family Owned Company - Outer Banks North Carolina
          </p>
          <p className="mt-1 text-[11px] text-blue-200/40">
            © {new Date().getFullYear()} Cornerstone Ops. All rights reserved.
          </p>
        </div>
        <div className="flex flex-col gap-3 sm:items-end">
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            {[
              { href: "/privacy", text: "Privacy Policy", id: "privacy" },
              { href: "/terms", text: "Terms of Service", id: "terms" },
              { href: "mailto:Info@priorityhousecleaning.com", text: "Contact", id: "contact" },
            ].map((l) => (
              <a
                key={l.id}
                href={l.href}
                data-testid={`footer-${l.id}`}
                className="inline-flex min-h-[44px] items-center text-xs font-semibold text-blue-100/75 transition-colors duration-200 hover:text-gold"
              >
                {l.text}
              </a>
            ))}
          </div>
          <div className="text-[11px] text-blue-200/50 sm:text-right" data-testid="footer-contact-detail">
            <p>
              Questions, billing or support:{" "}
              <a
                href="mailto:Info@priorityhousecleaning.com"
                data-testid="footer-email"
                className="font-semibold text-blue-100/80 underline-offset-2 hover:text-gold hover:underline"
              >
                Info@priorityhousecleaning.com
              </a>
            </p>
            {/* Deliberately phrased to keep the owner's personal cell for genuine emergencies. */}
            <p className="mt-1">
              Urgent only — system outage, payment or account security:{" "}
              <a
                href="tel:+12529952101"
                data-testid="footer-phone"
                className="font-semibold text-blue-100/80 underline-offset-2 hover:text-gold hover:underline"
              >
                (252) 995-2101
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  </>
);
